import { Modal, Box, useMediaQuery } from '@mui/material';

import { IAttendee } from '@src/webinar/types';
import InviteModalContent from './InviteModalContent';
import { TWebinarInviteesType } from '@src/types';
import { OResponsiveModal } from '@src/shared';
import styles from './inviteModal.module.scss';

const InviteModal = ({
  open,
  onClose,
  attendee,
  userRole,
  email,
  title,
  isRadioFieldsVisible = true,
  setAttendeesIdList,
}: {
  open: boolean;
  onClose: () => void;
  userRole?: TWebinarInviteesType;
  email?: string;
  title?: string;
  isRadioFieldsVisible?: boolean;
  attendee?: IAttendee;
  setAttendeesIdList?: (attendees: (prev: Set<string>) => Set<string>) => void;
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      {isMobile ? (
        <OResponsiveModal isOpen={open} onClose={onClose} title={title}>
          <Box className={styles.modalContent}>
            <InviteModalContent
              userRole={userRole}
              email={email}
              title={title}
              onClose={onClose}
              setAttendeesIdList={setAttendeesIdList}
              attendee={attendee}
              isRadioFieldsVisible={isRadioFieldsVisible}
              showCloseButton={false}
            />
          </Box>
        </OResponsiveModal>
      ) : (
        <Modal
          open={open}
          onClose={onClose}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box
            className={'bg-white p-4 shadow-lg outline-none overflow-y-auto rounded-xl w-full max-w-2xl mx-auto'}
            sx={{ display: 'flex', flexDirection: 'column' }}
          >
            <InviteModalContent
              userRole={userRole}
              email={email}
              title={title}
              onClose={onClose}
              setAttendeesIdList={setAttendeesIdList}
              attendee={attendee}
              isRadioFieldsVisible={isRadioFieldsVisible}
            />
          </Box>
        </Modal>
      )}
    </>
  );
};

export default InviteModal;
